import React, { useState, useContext } from "react";
// import PropTypes from "prop-types"
import tw, { css } from "twin.macro";
import * as s from "./cookiesAlert.module.css";
import { GeneralContext } from "../../contexts/generalContext";
import { useLocation } from "@reach/router"; // this helps tracking the location
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";

const CookiesAlert = () => {
  const generalContext = useContext(GeneralContext);
  const { t, forceShowCookies, setForceShowCookies, hasCookiesAlert } = generalContext;

  const [hasCookies, setHasCookies] = useState(typeof getCookie("gatsby-gdpr-google-analytics") !== "undefined");
  const [isCookieEstadisticas, setIsCookieEstadisticas] = useState(hasCookies ? getCookie("gatsby-gdpr-google-analytics") : true);
  const [isCookieMarketing, setIsCookieMarketing] = useState(hasCookies ? getCookie("gatsby-gdpr-facebook-pixel") : true);


  const location = useLocation();
  const onAccept = () => {
    document.cookie = `gatsby-gdpr-google-analytics=${isCookieEstadisticas ? "true" : "false"}; path=/`;
    document.cookie = `gatsby-gdpr-facebook-pixel=${isCookieMarketing ? "true" : "false"}; path=/`;
    initializeAndTrack(location);
    setHasCookies(true);
    setForceShowCookies(false);
  };

  if(!hasCookiesAlert){
    return null;
  }
  if (hasCookies && !forceShowCookies) {
    return null;
  }
  return (
    <div
      className={s.container}
    >
      <div className={s.content}>
        <div className={s.texto}>
          <strong>Cookies</strong>
          <p>
            {t.cookies.c1} {t.cookies.c2}.
          </p>
        </div>
        <div className={s.opcionesYBoton}>
          <div>
            <label css={[LabelCss, LabelCssDisabled, LabelCssOn]}>{t.cookies.required}</label>
            <label css={[LabelCss, isCookieEstadisticas && LabelCssOn]}
                   onClick={() => setIsCookieEstadisticas(!isCookieEstadisticas)}>{t.cookies.stats}</label>
            <label css={[LabelCss, isCookieMarketing && LabelCssOn]}
                   onClick={() => setIsCookieMarketing(!isCookieMarketing)}>{t.cookies.marketing}</label>
          </div>
          <button css={ButtonCss} onClick={onAccept}>{t.cookies.accept}</button>
        </div>
      </div>
    </div>
  );
};


function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}


const ButtonCss = css`
  font-size: 14px;
  text-transform: uppercase;
  margin: 10px auto 0 auto;
  padding: 8px 16px;
  color: white;
  background-color: #847360;
`;

const LabelCss = css`
  display: inline-block;
  position: relative;
  padding: 0 12px 0 22px;
  cursor: pointer;
  color: white;
  ${tw`text-obsmall2`}
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    width: 16px;
    height: 16px;
    border: 1px solid white;
  }
`;
const LabelCssDisabled = css`
  ${tw`opacity-50`}
  cursor: default;
`;
const LabelCssOn = css`
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 4px;
    top: 4px;
    width: 8px;
    height: 8px;
    background-color: white;
  }
`;

export default CookiesAlert;
